import { Grid } from '@mui/material'
import { Child } from '../../../../containers/common/child'
import { GItem } from '../grids'
import { UnitTitle } from './unitTitle'
import { getYesNoText } from '../../../../containers/common/category'
import { OperationId } from '../../../../containers/common/constant/operationLog'
import { GetCategoryMstDto } from '../../../../dataAccess/webApi/dto/categoryMstDto'
import { memberModifyChildDiseaseUrl } from '../../../../containers/common/constant/appUrl'

export const CATEGORY_NAME = 'disease'

interface ChildDiseaseUnitProps {
  child?: Child
  sectionLabel: string
  categoryMst?: GetCategoryMstDto[]
  hideLink?: boolean
}

export const ChildDiseaseUnit = (props: ChildDiseaseUnitProps) => {
  const { categoryMst, child, sectionLabel } = props
  if (child == null || categoryMst == null || categoryMst.length === 0) return null
  
  const targetCategory = categoryMst.find((value) => value.category === CATEGORY_NAME)
  if (!targetCategory) return null
  
  return (
    <>
      <UnitTitle title={sectionLabel} linkTo={memberModifyChildDiseaseUrl.url(child.childId)} operationLog={{ operationId: OperationId.OP_00000175 }} hideLink={props.hideLink} />
      <Grid container>
        <GItem xs={12}>{getYesNoText(targetCategory, child.diseaseFlag)}</GItem>
      </Grid>
    </>
  )
}